// Certifique-se de que sendDataAnalytics e debugView estão disponíveis globalmente

const LibSatUtil = {
  ObterValores: function () {
    const currentUrl = window.location.href;
    if (currentUrl.includes("localhost")) {
      return {
        ambienteLibSat: "TI",
        apiKeyLibSat: "qzVljgM5Bg27yb7UarbBw2n6Q2nHPS1l2EXnvYWO",
      };
    } else if (currentUrl.indexOf("-homol.") !== -1) {
      return {
        ambienteLibSat: "HML",
        apiKeyLibSat: "dvqQV3TXRG60bkNrAqxPS4BsHup69efh6Zcj3RqB",
      };
    } else {
      return {
        ambienteLibSat: "PRD",
        apiKeyLibSat: "SewC7ePkWv91PMrbPpLj63ajtOg4AUPN7LxmVN40",
      };
    }
  },

  /**
   * Navega de forma segura, validando protocolos e prevenindo javascript: e data: URIs
   * @param {string} href - URL para navegar
   * @param {string} target - Alvo (_blank, _self, etc.)
   */
  navigateSafely: function(href, target) {
    if (!href || href === "#") return;
    try {
      const url = new URL(href, window.location.origin);
      if (!["http:", "https:"].includes(url.protocol)) return;
      if (target === "_blank") {
        window.open(url.href, target, "noopener,noreferrer");
      } else {
        window.location.assign(url.href);
      }
    } catch {
      // URLs relativas: /caminho/interno
      if (href.startsWith("/") && !href.startsWith("//")) {
        window.location.assign(href);
      }
    }
  },

  /**
   * Escapa HTML para prevenir XSS ao usar textContent
   * @param {string} text - Texto para escapar
   * @returns {string} Texto escapado
   */
  escapeHtml: function(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  },
};
function preencherLibSat(type, eventPayload = {}) {
  try {
    // Ativa debug se a função existir
    if (typeof debugView === "function") {
      debugView(true);
    }

    // Envia para Google Tag Manager (dataLayer)
    window.dataLayer = window.dataLayer || [];
  const eventName =
      typeof eventPayload.event === "string" && eventPayload.event.trim() !== ""
        ? eventPayload.event
        : type;

    const payload = {
      ...eventPayload,
      event: eventName,
      libsatEventType: type,
    };

    window.dataLayer.push(
      payload,
    );

    //console.log(payload);

    // Envia para LibSat se disponível
    if (typeof sendDataAnalytics === "function") {
      const valores = LibSatUtil.ObterValores();
      sendDataAnalytics(
        type,
        payload,
        valores.ambienteLibSat,
        "scd",
        valores.apiKeyLibSat
      );
    }
  } catch (err) {
    console.error("Erro ao enviar Lib SAT", err);
  }
}
